import React from "react";

const AssessmentTypeList = ({ items, onSelect, title }) => {
	const list = items || [];
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover table-bordered">
					<thead>
						<tr>
							<th>sn</th>
							<th>Assessment Name</th>
							<th>Date </th>
							<th className="text-center">Edit </th>
						</tr>
					</thead>
					<tbody>
						{list.map((item, index) => (
							<tr key={index}>
								<td className="inbox-small-cells">
									<div className="todo-check pull-left">
										{index + 1}
									</div>
								</td>
								<td className="view-message">
									<h5>{item.name}</h5>
								</td>
								<td className="view-message">
									{new Date(
										parseInt(item.created_at)
									).toLocaleDateString("en-GB")}
								</td>
								<td className="view-message text-center">
									<button
										onClick={() => onSelect(item)}
										className="mdl-button mdl-button--icon mdl-button--colored btn-default"
									>
										<i className="material-icons text-success">
											edit
										</i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{list.length < 1 && (
					<div className="text-center m-t-10 m-b-10">
						<h5>No Assessment {title} is added yet!</h5>
					</div>
				)}
			</div>
		</div>
	);
};

export default AssessmentTypeList;
